import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

export const postPauseConcentrator = async () => {
  const response = await axiosMethods.post(RestAPI.PAUSE_CONCENTRATOR);
  return response;
};

export const postResumeConcentrator = async () => {
  const response = await axiosMethods.post(RestAPI.RESUME_CONCENTRATOR);
  return response;
};

export const postStopConcentrator = async (stopAction) => {
  const data = {
    StopAction: stopAction,
  };
  const response = await axiosMethods.post(RestAPI.STOP_CONCENTRATOR, data);
  return response;
};

export const postRefillConcentrator = async (volume) => {
  const data = {
    refilledVolume: volume,
  };
  const response = await axiosMethods.post(RestAPI.REFILL_CONCENTRATOR, data);
  return response;
};

export const postCancelRefillConcentrator = async () => {
  const response = await axiosMethods.post(RestAPI.CANCEL_REFILL_CONCENTRATOR);
  return response;
};

export const postNewStartConcentrator = async (proteinVolume, bufferVolume, deviceElementCheckList, profileConfig) => {
  const data = {
    VolumeConfirmation: {
      ProteinVolume: proteinVolume,
      BufferVolume: bufferVolume,
    },
    DeviceElementCheckList: deviceElementCheckList,
    ProfileConfig: profileConfig,
  };

  const response = await axiosMethods.post(RestAPI.NEW_START_CONCENTRATOR, data);
  return response;
};

export const postStopMixingConcentrator = async () => {
  const response = await axiosMethods.post(RestAPI.STOP_MIXING_CONCENTRATOR);
  return response;
};

export const postCancelSensorCheck = async () => {
  const response = await axiosMethods.post(RestAPI.CANCEL_SENSOR_CHECK);
  return response;
};
